<template>
  <div>
    <h3 class="flex items-center space-x-2 text-lg font-semibold">
      <span
        class="text-text-neutral-primary"
      >
        {{ dep }}
      </span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        class="text-situational-black"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="m14 5 7 7m0 0-7 7m7-7H3"
        />
      </svg>
      <span
        class="text-text-neutral-primary"
      >
        {{ arr }}
      </span>
    </h3>
    <p
      class="text-text-neutral-quaternary text-sm"
    >
      {{ t('duration', { duration }) }}
    </p>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  defineProps<{
    flightIdx?: number;
    sourcePage?: string;
    arr: string;
    dep: string;
    duration: string;
  }>();

  const { t } = useI18n();
</script>

<i18n src="../config/locales.json"></i18n>
